export interface Theme {
  id: string
  name: string
  description: string
  cssClass: string | null // null = default (no class added)
  themeColor: string // browser title bar / meta theme-color
  preview: {
    darker: string
    dark: string
    accent: string
  }
}

export const THEMES: Theme[] = [
  {
    id: 'default',
    name: 'Raven Dark',
    description: 'Default purple-dark theme',
    cssClass: null,
    themeColor: '#1a1a2e',
    preview: { darker: '#0f0f1a', dark: '#1a1a2e', accent: '#4a5568' },
  },
  {
    id: 'forever',
    name: 'WoW Forever',
    description: 'Teal and gold, from the logo',
    cssClass: 'theme-forever',
    themeColor: '#1a3546',
    preview: { darker: '#0e2130', dark: '#1a3546', accent: '#c5a072' },
  },
  {
    id: 'horde',
    name: 'Horde Red',
    description: 'For the Horde',
    cssClass: 'theme-horde',
    themeColor: '#2e1a1a',
    preview: { darker: '#1a0a0a', dark: '#2e1a1a', accent: '#8b3030' },
  },
  {
    id: 'alliance',
    name: 'Azure',
    description: 'Deep blue',
    cssClass: 'theme-alliance',
    themeColor: '#1a2040',
    preview: { darker: '#0a0f1a', dark: '#1a2040', accent: '#305080' },
  },
  {
    id: 'nature',
    name: 'Nature Green',
    description: 'Emerald Dream',
    cssClass: 'theme-nature',
    themeColor: '#1a2e20',
    preview: { darker: '#0a1a0f', dark: '#1a2e20', accent: '#308b40' },
  },
  {
    id: 'arcane',
    name: 'Arcane Purple',
    description: 'Arcane energies',
    cssClass: 'theme-arcane',
    themeColor: '#251a3e',
    preview: { darker: '#140f1a', dark: '#251a3e', accent: '#6b30a0' },
  },
  {
    id: 'argent',
    name: 'Argent Dawn',
    description: 'Light of the Dawn',
    cssClass: 'theme-argent',
    themeColor: '#e8e0d0',
    preview: { darker: '#f5f0e6', dark: '#e8e0d0', accent: '#b8952e' },
  },
  {
    id: 'light',
    name: 'Clean Light',
    description: 'Standard light theme',
    cssClass: 'theme-light',
    themeColor: '#ffffff',
    preview: { darker: '#f5f5f7', dark: '#ffffff', accent: '#6b7fa3' },
  },
  {
    id: 'slate',
    name: 'Slate',
    description: 'Cool gray light',
    cssClass: 'theme-slate',
    themeColor: '#edf2f7',
    preview: { darker: '#e2e8f0', dark: '#edf2f7', accent: '#64748b' },
  },
  {
    id: 'frost',
    name: 'Frost',
    description: 'Icy blue light',
    cssClass: 'theme-frost',
    themeColor: '#f7f9fd',
    preview: { darker: '#eef3fa', dark: '#f7f9fd', accent: '#4a7fb5' },
  },
  {
    id: 'gray',
    name: 'Light Gray',
    description: 'Neutral gray, VS Code style',
    cssClass: 'theme-gray',
    themeColor: '#f0f0f0',
    preview: { darker: '#e5e5e5', dark: '#f0f0f0', accent: '#007acc' },
  },
  {
    id: 'lavender',
    name: 'Lavender',
    description: 'Soft purple light',
    cssClass: 'theme-lavender',
    themeColor: '#ffffff',
    preview: { darker: '#F5F2FA', dark: '#ffffff', accent: '#6B4FA0' },
  },
  {
    id: 'eggshell',
    name: 'Eggshell',
    description: 'With Romalian type',
    cssClass: 'theme-eggshell',
    themeColor: '#FAF6ED',
    preview: { darker: '#F0EAD6', dark: '#FAF6ED', accent: '#5C4033' },
  },
  {
    id: 'pink',
    name: 'Mage Pink',
    description: 'Fabulous & fearless',
    cssClass: 'theme-pink',
    themeColor: '#3d1230',
    preview: { darker: '#2e0a1e', dark: '#3d1230', accent: '#ff69b4' },
  },
  // Shared with the Raven addon's themes
  {
    id: 'turtle',
    name: 'Turtle WoW',
    description: 'Turtle-shell green with gold',
    cssClass: 'theme-turtle',
    themeColor: '#132218',
    preview: { darker: '#0a130e', dark: '#132218', accent: '#3f8a34' },
  },
  {
    id: 'orgrimmar',
    name: 'Orgrimmar',
    description: 'Iron and stone, rust red and brass',
    cssClass: 'theme-orgrimmar',
    themeColor: '#211d1b',
    preview: { darker: '#121011', dark: '#211d1b', accent: '#a3301f' },
  },
  {
    id: 'undercity',
    name: 'Undercity',
    description: 'Plague green and royal purple',
    cssClass: 'theme-undercity',
    themeColor: '#1b1526',
    preview: { darker: '#0e0b14', dark: '#1b1526', accent: '#5e7d22' },
  },
  {
    id: 'thunderbluff',
    name: 'Thunder Bluff',
    description: 'Totem brown, sky blue and tan',
    cssClass: 'theme-thunderbluff',
    themeColor: '#221c14',
    preview: { darker: '#120f0b', dark: '#221c14', accent: '#2f78ad' },
  },
  {
    id: 'moltencore',
    name: 'Molten Core',
    description: 'Lava and ember',
    cssClass: 'theme-moltencore',
    themeColor: '#25130b',
    preview: { darker: '#140a06', dark: '#25130b', accent: '#d9541e' },
  },
  {
    id: 'naxxramas',
    name: 'Naxxramas',
    description: 'Necrotic green, cold stone',
    cssClass: 'theme-naxxramas',
    themeColor: '#10241d',
    preview: { darker: '#081410', dark: '#10241d', accent: '#2a9a70' },
  },
  {
    id: 'ahnqiraj',
    name: "Ahn'Qiraj",
    description: 'Desert sand and scarab gold',
    cssClass: 'theme-ahnqiraj',
    themeColor: '#271e10',
    preview: { darker: '#16110a', dark: '#271e10', accent: '#a87a1c' },
  },
  {
    id: 'zulgurub',
    name: "Zul'Gurub",
    description: 'Jungle teal and blood red',
    cssClass: 'theme-zulgurub',
    themeColor: '#0e2621',
    preview: { darker: '#071512', dark: '#0e2621', accent: '#b8325a' },
  },
  {
    id: 'midnight',
    name: 'Midnight',
    description: 'Near-black and silver',
    cssClass: 'theme-midnight',
    themeColor: '#16161a',
    preview: { darker: '#0b0b0d', dark: '#16161a', accent: '#626875' },
  },
  {
    id: 'light-pink',
    name: 'Demodar Light Pink',
    description: 'Pink but make it light',
    cssClass: 'theme-light-pink',
    themeColor: '#fff0f6',
    preview: { darker: '#ffe0ee', dark: '#fff0f6', accent: '#d6336c' },
  },
  // Easy to read: a light paper theme and a high contrast one
  {
    id: 'parchment',
    name: 'Parchment',
    description: 'Like an old quest log: cream paper, dark ink, deep red',
    cssClass: 'theme-parchment',
    themeColor: '#e8dcc0',
    preview: { darker: '#f3ead6', dark: '#e8dcc0', accent: '#8a2f1c' },
  },
  {
    id: 'highcontrast',
    name: 'High Contrast',
    description: 'Pure black, white text, strong borders',
    cssClass: 'theme-highcontrast',
    themeColor: '#0d0d0d',
    preview: { darker: '#000000', dark: '#0d0d0d', accent: '#1f4fd1' },
  },
  // Class themes
  {
    id: 'warrior',
    name: 'Warrior',
    description: 'Arms & fury',
    cssClass: 'theme-warrior',
    themeColor: '#2e2418',
    preview: { darker: '#1a140e', dark: '#2e2418', accent: '#C79C6E' },
  },
  {
    id: 'paladin',
    name: 'Paladin',
    description: 'Light be with you',
    cssClass: 'theme-paladin',
    themeColor: '#2e1a26',
    preview: { darker: '#1a0e14', dark: '#2e1a26', accent: '#F58CBA' },
  },
  {
    id: 'hunter',
    name: 'Hunter',
    description: 'Aspect of the wild',
    cssClass: 'theme-hunter',
    themeColor: '#1a2e16',
    preview: { darker: '#0e1a0a', dark: '#1a2e16', accent: '#ABD473' },
  },
  {
    id: 'rogue',
    name: 'Rogue',
    description: 'Shadow & poison',
    cssClass: 'theme-rogue',
    themeColor: '#2e2e16',
    preview: { darker: '#1a1a0a', dark: '#2e2e16', accent: '#FFF569' },
  },
  {
    id: 'priest',
    name: 'Priest',
    description: 'Power Word: Theme',
    cssClass: 'theme-priest',
    themeColor: '#1e1e24',
    preview: { darker: '#141418', dark: '#1e1e24', accent: '#d0d0e0' },
  },
  {
    id: 'shaman',
    name: 'Shaman',
    description: 'Elemental mastery',
    cssClass: 'theme-shaman',
    themeColor: '#142030',
    preview: { darker: '#0a0e1a', dark: '#142030', accent: '#0070DE' },
  },
  {
    id: 'mage',
    name: 'Mage',
    description: 'Frostbolt go brr',
    cssClass: 'theme-mage',
    themeColor: '#142430',
    preview: { darker: '#0a141a', dark: '#142430', accent: '#69CCF0' },
  },
  {
    id: 'warlock',
    name: 'Warlock',
    description: 'Shadow & flame',
    cssClass: 'theme-warlock',
    themeColor: '#201a30',
    preview: { darker: '#120e1a', dark: '#201a30', accent: '#9482C9' },
  },
  {
    id: 'druid',
    name: 'Druid',
    description: 'Shapeshifter',
    cssClass: 'theme-druid',
    themeColor: '#2e1e14',
    preview: { darker: '#1a100a', dark: '#2e1e14', accent: '#FF7D0A' },
  },
]

export const THEME_STORAGE_KEY = 'raven-theme'

export function getThemeById(id: string): Theme | undefined {
  return THEMES.find(t => t.id === id)
}
